var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquattingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.293 22.293-8.586-8.586c-.63-.63-.184-1.707.707-1.707h17.172c.89 0 1.337 1.077.707 1.707l-8.586 8.586a1 1 0 0 1-1.414 0Zm0-11L2.707 2.707C2.077 2.077 2.523 1 3.414 1h17.172c.89 0 1.337 1.077.707 1.707l-8.586 8.586a1 1 0 0 1-1.414 0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquattingInactive);
export default __webpack_public_path__ + "static/media/squatting-inactive.3d7e7ec5e926e97af2b849aa93f3ae89.svg";
export { ForwardRef as ReactComponent };